import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

type AdditionalClassGroupIDs = 'text-color' | 'icon-color' | 'icon-size'

const twMerge = extendTailwindMerge<AdditionalClassGroupIDs>({
  extend: {
    classGroups: {
      'text-color': [
        {
          text: [
            'primary',
            'primary-inverse',
            'secondary',
            'tertiary',
            'quaternary',
            'brand-primary',
            'brand-secondary',
            'brand-tertiary',
            'brand-quaternary',
            'system-success-primary',
            'system-success-secondary',
            'system-warning-primary',
            'system-error-primary',
            'system-error-secondary',
            'feature-savings-primary',
            'feature-savings-secondary',
            'feature-borrow-primary',
            'feature-borrow-secondary',
            'feature-farms-primary',
            'feature-farms-secondary',
          ],
        },
      ],
      'icon-color': [
        {
          icon: [
            'primary',
            'primary-inverse',
            'secondary',
            'tertiary',
            'brand-primary',
            'brand-secondary',
            'system-success-primary',
            'system-success-secondary',
            'system-warning-primary',
            'system-warning-secondary',
            'system-error-primary',
            'system-error-secondary',
          ],
        },
      ],
      'icon-size': [
        {
          'icon-size': ['xxs', 'xs', 'sm', 'md'],
        },
      ],
    },
    conflictingClassGroups: {
      'text-color': ['icon-color'],
      'icon-color': ['text-color'],
      size: ['icon-size'],
      'icon-size': ['size'],
    },
  },
})

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
